export default function reducerCustomers(state = {}, action) {
  switch (action.type) {
    case 'GET_BANNERS':
      return {
        ...state,
        banners: action.payload.data,
      }
    default:
      return state
  }
}
